import React, {Fragment, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Loader from "../../components/shared/Loader/Loader";
import { SharedApi } from "../../services/Shared.api";


const LogPage = () => {
  const {deviceId} = useParams();
  const navigate = useNavigate();
  const [loading, SetLoading] = useState(true);
  const [logs, setLogs] = useState([])

  useEffect(() => {
    populateDevicesData(deviceId)
  }, [deviceId]);

  const populateDevicesData = async (deviceId) => {
    try {
      const data = await SharedApi.getDeviceLogs(deviceId);
      setLogs(data.logs ?? []);
    } catch (error) {
      console.error('Ошибка загрузки логов:', error);
    } finally {
      SetLoading(false)
    }
  }

  const render = () => {
    return (
      <><Fragment>
        <div className="mb-3">
          <button className="btn btn-link" onClick={() => navigate("/devices", { replace: true })}>К списку устройств
          </button>

        </div>
        {loading
          ? <Loader />
          : content() }
      </Fragment>

      </>
    )
  }

  const content = () => {
    return (
      <Fragment>
        {
          logs.map(x => <p>{x.insertDateTime} {x.data}</p>)
        }
      </Fragment>
    );
  }

  return render();
};

export default LogPage;
